// Relative timestamp — "5 minutes ago" / "منذ ٥ د", falling back to an absolute
// short date past 30 days. Extracted from DashboardBuyer.jsx (which keeps its own
// copy) so the admin request boards can share one implementation.
export function relativeTime(dateStr, isAr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  const hrs  = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);
  if (isAr) {
    if (mins < 1)  return 'الآن';
    if (mins < 60) return `منذ ${mins} د`;
    if (hrs < 24)  return `منذ ${hrs} س`;
    if (days < 30) return `منذ ${days} يوم`;
    return new Date(dateStr).toLocaleDateString('ar-SA-u-nu-latn', { month: 'short', day: 'numeric' });
  }
  if (mins < 1)  return 'just now';
  if (mins < 60) return `${mins}m ago`;
  if (hrs < 24)  return `${hrs}h ago`;
  if (days < 30) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export default relativeTime;
